module.exports = __webpack_public_path__ + "static/styledcomponents-f32de4a1fcc2b93f5f276d9e0d43ef5e.png";